import { useState } from "react";
import { useAuthContext } from "../../contexts/auth";
import {updateQueryString} from "../../util/url";
import {useRouter} from "next/router";

// @material-ui/core components
import { makeStyles } from "tss-react/mui";
import { Select, MenuItem } from "@mui/material";

// core components
import Button from "../CustomButtons/Button.js";

// sections for this page
import ForumsBlockerModal from "../ForumsBlockerModal/ForumsBlockerModal.js";
import ForumsMeetApprenticesPanel from "../ForumsMeetApprenticesPanel/ForumsMeetApprenticesPanel.js";
import ForumsTopicCard from "../ForumsTopicCard/ForumsTopicCard.js";
import ForumsTopicAddPost from "../ForumsTopicAddPost/ForumsTopicAddPost.js";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";

import {useTopicListContext} from "../../contexts/topicList";
import {useForumContext} from "../../contexts/forum";

const useStyles = makeStyles()(styles);

export function TopicSortSelect(props) {
  return (
    <Select
      value={props.value}
      inputProps={{ "aria-label": "Without label" }}
      className={props.classes.topicFilter}
      onChange={props.onChange}
    >
      <MenuItem value={"popular"} className={props.classes.topicFilterText}>
        Popular (default)
      </MenuItem>
      <MenuItem value={"recent"} className={props.classes.topicFilterText}>
        Most recent
      </MenuItem>
      <MenuItem value={"likes"} className={props.classes.topicFilterText}>
        Most upvoted
      </MenuItem>
      <MenuItem value={"replies"} className={props.classes.topicFilterText}>
        Most replies
      </MenuItem>
    </Select>
  );
}

export default function ForumsTopicsSection(props) {
  const { classes, cx } = useStyles();
  const { topics, data } = props;

  const { auth } = useAuthContext();
  const router = useRouter();
  const { setSortBy, sortBy, reloadTopics } = useTopicListContext();
  const { forums } = useForumContext();

  const [textEditorOpen, setTextEditorOpen] = useState(false);
  const [blockerOpen, setBlockerOpen] = useState(false);

  const openTextEditor = async () => {
    if (auth.user == null) {
      await router.push(updateQueryString(updateQueryString(router.asPath, "login", null), "redirectUrl", router.asPath));
    } else {
      if (forums.isAtPostLimit) {
        setBlockerOpen(true);
      } else {
        setTextEditorOpen(true);
      }
    }
  };

  const closeTextEditor = () => {
    setTextEditorOpen(false);
  };

  const handleSortChange = (event) => {
    setSortBy(event.target.value);
  };

  return (
    <div className={classes.topicsContainer}>
      <div
        className={cx(
          classes.topicCard +
            " " +
            classes.mobileView +
            " " +
            classes.apprenticeContainer
        )}
      >
        <ForumsMeetApprenticesPanel data={data} apprentices={data?.category?.guestPosters} />
        <Button
          className={cx(classes.darkButton + " " + classes.newTopicButton)}
          onClick={openTextEditor}
        >
          Ask a question
        </Button>
      </div>
      <div className={classes.topicsHeader}>
        <h1 className={classes.topicsTitle}>Community questions</h1>
        <div className={classes.topicButtons}>
          <TopicSortSelect
            value={sortBy}
            classes={classes}
            onChange={handleSortChange}
          />
          <Button
            className={cx(classes.darkButton + " " + classes.newTopicButton)}
            onClick={openTextEditor}
          >
            Ask a question
          </Button>
        </div>
      </div>
      <ForumsTopicAddPost topic={null} open={textEditorOpen} onClose={closeTextEditor} />
      {blockerOpen && (
        <ForumsBlockerModal
          type={"timeout"}
          open={blockerOpen}
          onClose={() => setBlockerOpen(false)}
        />
      )}
      {topics && topics.map((topic, index) => (
        <ForumsTopicCard
          reload={reloadTopics}
          topic={topic}
          key={topic.topicId}
          postView={false}
          community={props.data.category.name}
          initial={true}
        />
      ))}
    </div>
  );
}

